import styles from "./Retailers.styles";
import Book from "./sections/Book";
import Helps from "./sections/Helps";
import Hero from "./sections/Hero";
import How from "./sections/How";
import Seo from "../../components/Seo";
import { useI18n } from "../../i18n";

export default function Retailers() {
  const { t } = useI18n();
  return (
    <div className={`${styles.container}`}>
      <Seo title={t("seo_retailers_title")} description={t("seo_retailers_desc")} />
      <Hero />
      <How />
      <Helps />
      <Book/>
    </div>
  );
}
